import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, Search } from 'lucide-react';
import { productsAPI } from '../services/api';
import { useT } from '../services/i18n';

const ProductFitments = ({ productId, fallback }) => {
  const { t } = useT();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(null);
  const [q, setQ] = useState('');

  useEffect(() => {
    let cancelled = false;
    setData(null); setOpen(null); setQ('');
    productsAPI.getFitments(productId).then(d => { if (!cancelled) setData(d); }).catch(() => { if (!cancelled) setData({ total: 0, brands: [] }); });
    return () => { cancelled = true; };
  }, [productId]);

  if (!data) return null;
  if (!data.total) return fallback;
  const term = q.trim().toLowerCase();
  const brands = data.brands.map(b => ({ ...b, models: term ? b.models.filter(m => `${b.brand} ${m.model} ${m.engines.map(e => e.engine).join(' ')}`.toLowerCase().includes(term)) : b.models })).filter(b => b.models.length);
  return (
    <div data-testid="product-fitments">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <p className="text-sm text-gray-600" data-testid="product-fitments-count">{t('fitments.count', { n: data.total, b: data.brands.length })}</p>
        <div className="relative">
          <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t('fitments.filter')} data-testid="product-fitments-filter" className="pl-8 pr-3 py-1.5 text-sm border rounded-md w-64" />
        </div>
      </div>
      <div className="space-y-2 max-h-96 overflow-y-auto pr-1">
        {brands.map(b => {
          const isOpen = open === b.brand || !!term;
          return (
            <div key={b.brand} className="border rounded-lg" data-testid={`product-fitments-brand-${b.brand}`}>
              <button type="button" onClick={() => setOpen(isOpen && !term ? null : b.brand)} className="w-full flex items-center justify-between px-3 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50">
                <span>{b.brand} <span className="text-xs text-gray-500 font-normal">{t('fitments.models', { n: b.models.length, count: b.models.length })}</span></span>
                <ChevronDown size={16} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
              </button>
              {isOpen && (
                <div className="px-3 pb-3 space-y-2">
                  {b.models.map(m => (
                    <div key={m.model}>
                      <p className="text-xs font-medium text-gray-800">{m.link ? <Link to={m.link} className="hover:text-orange-600 hover:underline" data-testid={`product-fitments-link-${m.model}`}>{m.model}</Link> : m.model}</p>
                      <ul className="mt-0.5 flex flex-wrap gap-1">
                        {m.engines.map((e, i) => <li key={i} className="text-[11px] bg-gray-100 text-gray-700 px-2 py-0.5 rounded-full">{e.engine}{e.years ? <span className="text-gray-400"> · {e.years}</span> : null}</li>)}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
        {brands.length === 0 && <p className="text-sm text-gray-500">{t('fitments.noMatch', { q })}</p>}
      </div>
    </div>
  );
};

export default ProductFitments;
